import { render, staticRenderFns } from "./LatestUsers.vue?vue&type=template&id=5abdabc2&"
import script from "./LatestUsers.vue?vue&type=script&lang=js&"
export * from "./LatestUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports